import { render } from "./gaji-list-lookup.vue?vue&type=template&id=22d27310"
import script from "./gaji-list-lookup.vue?vue&type=script&lang=js"
export * from "./gaji-list-lookup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__